// Invoice design settings - used for printable invoices (Farsi/RTL)
const invoiceDesign = {
    shopName: 'فکت پلاست',
    shopNameEn: 'Fact Plast',
    address: 'ایران، البرز، کارخانه فکت پلاست',
    phone: '+989192434079',
    logo: '/images/factplast-logo.png',
    // 3 template options: 'classic' | 'minimal' | 'modern'
    defaultTemplate: 'classic',
    footerText: 'برای استعلام قیمت تماس بگیرید',
}

// Panel connection settings.
// Change these values by hand before running `npm run build`.
const panelApiRoot = 'https://factplast.com/factplast/'
const panelApiDomain = 'https://factplast.com/factplast/'
const panelAssetsDomain = 'https://cdn.factplast.com/'
const panelSocketDomain = 'https://factplast.com/users/'


const siteConfig = {
    // languages: ["en"],
    languages: ["fa"],

    defaultLng: 'fa',
    dontShowUrlForDefaultLng: true,
    forceUrl: false,


    showCart: false,
    showProfile: false,
    showLanguage: false,
    showDeliveryCalcText: false,


    

    rootDomain: panelApiRoot,
    domain: panelApiDomain,
    assetsDomain: panelAssetsDomain,
    socketDomain: panelSocketDomain,

   

    name: 'FactPlast.com',
    siteName: 'Fact Plast',
    phone: '+989192434079',
    productColors: [
        { title: 'سفید', slug: 'white', hex: '#ffffff', textColor: '#111827' },
        { title: 'مشکی', slug: 'black', hex: '#111827', textColor: '#ffffff' },
        { title: 'زرد', slug: 'yellow', hex: '#facc15', textColor: '#111827' },
        { title: 'نارنجی', slug: 'orange', hex: '#f97316', textColor: '#ffffff' },
        { title: 'سبز', slug: 'green', hex: '#22c55e', textColor: '#ffffff' },
        { title: 'آبی', slug: 'blue', hex: '#2563eb', textColor: '#ffffff' },
        { title: 'قرمز', slug: 'red', hex: '#ef4444', textColor: '#ffffff' },
        { title: 'صورتی', slug: 'pink', hex: '#ec4899', textColor: '#ffffff' },
    ],
    instagram: 'https://instagram.com/factplast',
    email: 'info@factplast.com',
    facebook: '',
}
const siteTheme = {


    logo: '/images/factplast-logo.png',
    logo_s: '/images/factplast-logo.png',
    // invertLogo: true,


    themeColors: { headerBack: '#f2f7f8', headerFont: '#000000' },
    // themeColors: { headerBack: '#46196f', headerFont: '#ffffff' },
    // themeColors: { headerBack: '#000000', headerFont: '#ffffff' },



    backgroundColors: { normal: '#e2e8ea', plus: '#0d9488', luxury: '#101010', custom: '#d3b564' },
    colors: { normal: '#202020', plus: '#fff', luxury: '#fff', custom: '#101010' },
}

const brandColors = {
    primary: '#0d9488',
    primaryDark: '#0f766e',
    primaryLight: '#ccfbf1',
    accent: '#0891b2',
    danger: '#dc2626',
    dangerDark: '#b91c1c',
}

const languagesInfo = {
    en: {
        shortName: 'en',
        direction: 'ltr',
        name: 'English',
        icon: 'https://image.flaticon.com/icons/svg/197/197484.svg'
    },
    fa: {
        shortName: 'fa',
        direction: 'rtl',
        name: 'فارسی',
        icon: 'https://image.flaticon.com/icons/svg/197/197574.svg'
    }
}


let apisList = {


    // EMPLOYEES
    employeeLogin: { route: 'employees/authenticate', server: 'yc', hashMethod: '', auth: null, params: [], flexibleParams: true },
    employeeAdd: { route: 'employees/add', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    employeeGetAll: { route: 'employees/getAll', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    employeeRemove: { route: 'employees/remove', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    employeeGetInfo: { route: 'employees/getInfo', server: 'yc', hashMethod: '', auth: 'token', params: [], auth: 'token', flexibleParams: true },

 // permissions 
 getPermissions: { route: 'permissions/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 addPermission: { route: 'permissions/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removePermission: { route: 'permissions/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 getPermission: { route: 'permissions/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },



    
    // USER
    userCheck: { route: 'users/check', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    userLogin: { route: 'users/authenticate', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userSendCode: { route: 'users/signup/verifyCode', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    //Todo create user
    userPostInfo: { route: 'users/signup/postInfo', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    userForgetPassword: { route: 'users/forgotPassword', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    userForgetPasswordVerifyCode: { route: 'users/forgotPassword/verifyCode', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userForgetPasswordPostPassword: { route: 'users/forgotPassword/postPassword', server: 'yc', hashMethod: '', auth: 'token', flexibleParams: true },
    // userUpdate: { route: 'users/add', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userUpdate: { route: 'users/updateFromPanel', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    getUsers: { route: 'users/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // teachersGetAll: { route: 'users/getAllTeachers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getAllMalls: { route: 'users/getMalls', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getAllBrands: { route: 'users/getBrands', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userRemove: { route: 'users/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userGetInfo: { route: 'users/getInfo', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userAuthVerifyCode: { route: 'users/signin/verifyCode', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userUpdateInfo: { route: 'users/updateInfo', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userRegisterDevice: { route: 'users/registerDevice', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    userUnregisterDevice: { route: 'users/unregisterDevice', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    // category
    categoryAdd: { route: 'categories/addCategory', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    getCategories: { route: 'categories/getAllCategory', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    removeCategory: { route: 'categories/removeCategory', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },


     // Contents
     getContents: { route: 'content/getContents', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
     postContent: { route: 'content/postContent', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
     removeContent: { route: 'content/removeContent', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 

     

    // Specification
    getAllSpecifications: { route: 'categories/getAllSpecifications', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    addSpecifications: { route: 'categories/addSpecifications', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    RemoveSpecifications: { route: 'categories/RemoveSpecifications', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
 //! do not need this in front
 getFilteredSpecifications: { route: 'categories/getFilteredSpecifications', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
 //! do not need this in front
    // // cities
    // addCities: { route: 'config/addCities', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // getAllCities: { route: 'config/getAllCities', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // RemoveCities: { route: 'config/RemoveCities', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    // // Countries
    // addCountries: { route: 'config/addCountries', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // getAllCountries: { route: 'config/getAllCountries', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // removeCountries: { route: 'config/config/removeCountries', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    // // permissions
    // addPermission: { route: 'permissions/addPermission', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // getPermissions: { route: 'permissions/getPermissions', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // removePermission: { route: 'permissions/removePermission', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // getOnePermissions: { route: 'permissions/getOnePermissions', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

 // baners
 postBaner: { route: 'baners/postBaner', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
 getbaners: { route: 'baners/getAll', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
 removebaner: { route: 'baners/removeBaner', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
 getOneBaner: { route: 'baners/getOneBaner', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },


 //blogs
 getBlogs: { route: 'blogs/getBlogs', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postBlog: { route: 'blogs/postBlog', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeBlog: { route: 'blogs/removeBlog', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 //brands
 getBrands: { route: 'brands/getBrands', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postBrand: { route: 'brands/postBrand', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeBrand: { route: 'brands/removeBrand', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 getColors: { route: 'colors/getColors', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postColor: { route: 'colors/postColor', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeColor: { route: 'colors/removeColor', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

 // Shop
 getProducts: { route: 'shop/getProducts', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postProduct: { route: 'shop/postProduct', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeProduct: { route: 'shop/removeProduct', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 
 getPartners: { route: 'partners/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postPartners: { route: 'partners/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removePartners: { route: 'partners/Remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


 getAccounts: { route: 'accounts/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postAccounts: { route: 'accounts/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeAccounts: { route: 'accounts/Remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

 getSizes: { route: 'shop/getSizes', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postSize: { route: 'shop/postSize', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeSize: { route: 'shop/removeSize', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


 getOrders: { route: 'shop/getOrders', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postOrder: { route: 'shop/postOrder', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeOrder: { route: 'shop/removeOrder', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 changeProductPrices: { route: 'shop/changeProductPrices', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

 getAddresses: { route: 'shop/getAddresses', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postAddress: { route: 'shop/postAddress', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeAddress: { route: 'shop/removeAddress', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

 getShopPayments: { route: 'shop/getShopPayments', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postShopPayment: { route: 'shop/postShopPayment', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeShopPayment: { route: 'shop/removeShopPayment', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

 getDocs: { route: 'documentation/getDocs', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 postDoc: { route: 'documentation/postDoc', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
 removeDoc: { route: 'documentation/removeDoc', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    // // messages
    // getMessages: { route: 'messages/getMessages', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // postMessage: { route: 'messages/postMessage', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // removeMessage: { route: 'messages/removeMessage', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    // // blogs
    // getBlogs: { route: 'blogs/getBlogs', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // postBlog: { route: 'blogs/postBlog', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // removeBlogs: { route: 'blogs/removeBlog', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

   

    // // types
    // getTypes: { route: 'types/getAll', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // postTypes: { route: 'types/add', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // removeTypes: { route: 'types/Remove', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    // // videos
    // getVideos: { route: 'videos/getAll', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // postVideo: { route: 'videos/add', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // removeVideo: { route: 'videos/remove', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

    // // podcasts
    // getpodcasts: { route: 'podcasts/getAll', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // postpodcast: { route: 'podcasts/postpodcast', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },
    // removepodcast: { route: 'podcasts/remove', server: 'yc', hashMethod: '', auth: 'token', params: [], flexibleParams: true },

   


}


export { siteConfig, siteTheme, brandColors, languagesInfo, apisList, invoiceDesign }
